import { render, staticRenderFns } from "./TranslatedItem.vue?vue&type=template&id=4661ec0c&scoped=true&"
import script from "./TranslatedItem.vue?vue&type=script&lang=ts&"
export * from "./TranslatedItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4661ec0c",
  null
  
)

export default component.exports